<template>
  <div class="bet-slip bet-slip-teaser">
    <div class="bet-slip-content with-title" :class="{'bgColorWhite' : isScanningCodeForMobile}">
      <bet-slip-title>{{ getTranslatedBetType('teaser') }}</bet-slip-title>
      <!-- Bet Line  -->
      <div v-for="bet in [getTeasers()]" :key="bet.id">
        <bet-alert-message v-if="!bet.IsSuccess" :description="parseBetErrorMessage(bet)" />
        <div v-else>
          <div class="bet-scroll-wrapper">
            <bet-slip-selection
              class="bet-slip-item-wrapper"
              v-for="selection in bet.Selections"
              :key="selection.OutComeId"
              :selection="selection"
              :showCheckbox="false"
              :showBuyPoints="false"
              @onBuyPointChange="onRiskChange(bet)"
              @onRemove="removeBetFromSelections(selection.OutComeId)"
              @accept="onRiskChange(bet)"
            >
            </bet-slip-selection>
          </div>
          <div class="bet-slip-item-wrapper" style="border: 0">
            <span class="bet-slip-bet-type-title">{{ $t('BetSlip.ChooseOption.Teaser') }}</span>
            <select
              class="form-control bet-slip-form-control w-100"
              v-model="wagerTypeId"
              @change="onTeaserChange(bet, $event)"
            >
              <template v-if="getTeaserOptions() && Object.values(getTeaserOptions()).length">
                <option
                  v-for="opt in Object.values(getTeaserOptions()).sort((a, b) => {
                    return parseInt(b.Odds) - parseInt(a.Odds);
                  })"
                  :key="opt.IdWagerType"
                  :value="opt.IdWagerType"
                >
                  {{ opt.Description }}
                </option>
              </template>
            </select>
          </div>
          <div class="bet-slip-item-wrapper" style="border: 0">
            <div class="row">
              <div class="col-6">
                <bet-slip-risk-input
                  class="w-100"
                  :amount.sync="bet.input_risk_amount"
                  @change="onRiskChange(bet)"
                  :min="getRiskInputMinAmount(bet)"
                  :max="getBetMaxLimit(bet)"
                  :limit-control="hasError('RISK', bet)"
                  type="RISK"
                  :is-custom-limit-control="true"
                ></bet-slip-risk-input>
              </div>
              <div class="col-6">
                <bet-slip-risk-input
                  class="w-100"
                  :amount.sync="bet.input_win_amount"
                  :riskedAmount="bet.input_risk_amount"
                  @change="onWinChange(bet)"
                  :min="getBetMinLimit(bet)"
                  :max="getMaxPayoutLimit(bet)"
                  :limit-control="hasError('WIN', bet)"
                  type="WIN"
                  :is-custom-limit-control="true"
                ></bet-slip-risk-input>
              </div>
              <div class="col-12">
                <div
                  class="betslip-input-error pt-1 p-0"
                  v-if="minErrorCondition(bet) && !minBetConditionByBet(bet)"
                  v-html="betSlipMinError(getBetMinLimit(bet), bet)"
                ></div>
              </div>

              <div class="col-12">
                <div
                  class="betslip-input-error pt-1 p-0"
                  v-if="maxErrorCondition(bet) && !minBetConditionByBet(bet)"
                  v-html="betSlipMaxError(getBetMaxLimit(bet), bet)"
                ></div>
              </div>

              <div class="col-12">
                <div
                  class="betslip-input-error error-3 pt-1 p-0"
                  v-if="minBetConditionByBet(bet)"
                  v-html="minBetConditionError()"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <total-amounts
        class="mt-1"
        :totalBets="getTotalBetsCount()"
        :totalRiskAmount="getTotalRiskAmount()"
        :totalRiskAmountWithoutTax="getTotalRiskAmountWithoutTax()"
        :totalWinAmount="getTotalWinAmount()"
        :showFreePlayIfEligible="true"
        :betOptionsResponse="getTeasers()"
        :disable-place-bet-button="disablePlaceBetButton"
        :wagerType="getWagerType()"
      ></total-amounts>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { getSelectedTeaserObjectFromBetOptions, roundAmount } from './bet-slip-utils';
import BetSlipMixin from './bet-slip-mixin';

export default {
  mixins: [BetSlipMixin],
  data() {
    return {
      wagerTypeId: null,
    };
  },
  watch: {
    betOptionsResponse() {
      const teaserOption = getSelectedTeaserObjectFromBetOptions(
        this.getTeasers(),
        this.wagerTypeId,
        'returnFirstIfNotFound',
      );
      if (teaserOption) {
        const bet = this.getTeasers();
        if (!bet) return;
        this.createOrUpdateBet(
          this.createBet(
            'teaser',
            '',
            bet.input_risk_amount,
            bet.input_win_amount,
            0,
            bet.open_spots,
            teaserOption.IdWagerType,
          ),
        );
        this.wagerTypeId = teaserOption.IdWagerType;
      }
    },
    activeFreeBet() {
      let betSlipObj = this.getTeasers();
      this.onRiskChange(betSlipObj);
    }
  },
  mounted() {
    if (this.getTeasers()) {
      if (this.getTeasers() && this.getTeasers().AvailableTeaserPoints) {
        let teaserTable = this.getTeasers();
        this.wagerTypeId = teaserTable.IdWagerType;
      }
      this.onRiskChange(this.getTeasers());
    }
    this.onTeaserChange(this.getTeasers());
  },

  computed: {
    ...mapGetters('player', ['currency', 'currencySymbol']),
    ...mapState({
      currency: (state) => state.settings.terminalInfo.currency_symbol,
      selectedOddType: (state) => state.settings.selectedOddType,
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
      isScanningCodeForMobile: state => state.settings.isScanningCodeForMobile,
    }),
    disablePlaceBetButton() {
      return (
        this.minErrorCondition(this.getTeasers()) ||
        this.maxErrorCondition(this.getTeasers()) ||
        this.minBetConditionByBet(this.getTeasers())
      );
    },
  },

  methods: {
    ...mapActions({
      updateTeaserSelection: 'betSlip/updateTeaserSelection',
    }),
    getWagerType() {
      return 'teaser';
    },
    getTeaserOptions() {
      let betSlipObj = this.getTeasers();
      // let selectionFirst = betSlipObj.Selections[0];
      return betSlipObj.AvailableTeaserPoints;
    },
    onRiskChange(bet) {
      if (!bet.input_risk_amount) return;

      if (this.activeFreeBet) {
        bet.input_win_amount =
          this.fixWinAmount(
            bet,
            this.roundAmount(bet.input_risk_amount * this.americanToDecimal(this.getTeaserOdd())),
          );
      } else {
        bet.input_win_amount =
          this.fixWinAmount(
            bet,
            this.roundAmount(bet.input_risk_amount * this.americanToDecimal(this.getTeaserOdd())),
          ) - this.roundAmount(bet.input_risk_amount);
      }

      if (this.$taxHelper.mustApplyTax) {
        const input_risk_amount = bet.input_risk_amount;
        if (input_risk_amount != '') {
          const appliedTaxToWinInputHidden = this.fixWinAmount(
            bet,
            this.roundAmount(
              this.$taxHelper.applyTaxToRiskInputHidden({
                input_risk_amount,
              }) * this.americanToDecimal(this.getTeaserOdd()),
            ),
          );

          if (parseFloat(appliedTaxToWinInputHidden) < 0) {
            bet.input_win_amount = '';
          } else {
            bet.input_win_amount = this.roundAmount(appliedTaxToWinInputHidden);
          }
        }
      }

      this.notifyBetSlip(bet);
    },
    onWinChange(bet) {
      bet.input_risk_amount = this.roundAmount(bet.input_win_amount / this.americanToDecimal(this.getTeaserOdd()));
      this.notifyBetSlip(bet);
    },
    onTeaserChange(bet) {
      let betSlipObj = this.getTeasers();
      let teaserOptions = betSlipObj.AvailableTeaserPoints;
      const subType = this.wagerTypeId; // wager_type_id
      let selectedTeaserOption = teaserOptions.find((f) => f.IdWagerType == subType);
      this.updateTeaserSelection({
        wager_type_id: subType,
        selected_teaser: selectedTeaserOption,
      });
      this.onRiskChange(bet);
      this.createOrUpdateBet(
        this.createBet(bet.type, '', bet.input_risk_amount, bet.input_win_amount, 0, bet.open_spots, subType),
      );
    },
    notifyBetSlip(bet) {
      this.createOrUpdateBet(
        this.createBet(bet.type, '', bet.input_risk_amount, bet.input_win_amount, 0, bet.open_spots, this.wagerTypeId),
      );
    },
    getTotalRiskAmount() {
      let total = 0;
      let bet = this.getTeasers();
      total +=
        bet.input_risk_amount === ''
          ? 0
          : parseFloat(
              this.$taxHelper.applyTaxToRiskInputHidden({
                input_risk_amount: bet.input_risk_amount,
              }),
            );

      if (parseFloat(total) < 0) {
        return 0;
      }
      return this.roundAmount(total);
    },
    getTotalRiskAmountWithoutTax() {
      let total = 0;
      let bet = this.getTeasers();
      total += bet.input_risk_amount === '' ? 0 : parseFloat(bet.input_risk_amount);
      return this.roundAmount(total);
    },
    getTotalWinAmount() {
      let total = 0;
      let bet = this.getTeasers();
      total += bet.input_win_amount === '' ? 0 : parseFloat(bet.input_win_amount);
      if (parseFloat(total) < 0) {
        return 0;
      }
      return this.roundAmount(total);
    },
    getTeaserOdd() {
      const teaserOption = getSelectedTeaserObjectFromBetOptions(
        this.getTeasers(),
        this.wagerTypeId,
        'returnFirstIfNotFound',
      );
      return teaserOption ? teaserOption.Odds : 0;
    },
    getTotalBetsCount() {
      let bet = this.getTeasers();
      if (bet.input_win_amount > 0) {
        return 1;
      }
      return 0;
    },
    triggerRiskChangeForAllBets() {
      let bet = this.getTeasers();
      this.onRiskChange(bet);
    },
  },
};
</script>
